// components/banners/ConnectBanner.jsx

import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import NewsletterModal from '../modals/web-modals/NewsletterModal';
import AVIcon from '../icons/AllVoicedIcons';

const ConnectBanner = () => {
  const { t } = useTranslation();
  const [isModalOpen, setModalOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <section className="connect-banner">
      <div className="connect-banner__content">
        <AVIcon icon="heartHandsShake" size={56} color="#209385" />
        <h2 className="connect-banner__title">
          {t('connect_banner.title', 'Stay connected with All-Voiced')}
        </h2>

        <p className="connect-banner__text">
          {t(
            'connect_banner.text',
           'Join a growing ecosystem of clinicians, educators, researchers, students, dataset owners, and voice technology teams using auditory-perceptual voice assessment to train listeners, support research, and build voice technologies.'
          )}
        </p>

        <div className="connect-banner__buttons web-cta-row">
          <button
            type="button"
            className="web-button web-button--primary"
            onClick={() => setModalOpen(true)}
          >
            {t('subscribe_to_newsletter', 'Subscribe')}
          </button>

          <button
            type="button"
            className="web-button web-button--secondary"
            onClick={() => navigate('/connect')}
          >
            {t('get_connected', 'Get connected')}
          </button>
        </div>

        <NewsletterModal
          isOpen={isModalOpen}
          onRequestClose={() => setModalOpen(false)}
        />
      </div>
    </section>
  );
};

export default ConnectBanner;
